<template>

<div v-if="dissave"  style="position:absolute; top: 300px;   width: 100%; z-index:100;  ">
  <Circle4 size="120px" class="mx-auto"></Circle4>
</div>

<div class="col mb-4 p-3">
    <div class="card border-left-primary shadow h-100 py-2 p-3">


        <h3 class="font-weight-bold text-primary">Рӯйхати китобҳо</h3>

        <p>
            <button @click="fetchBook()" class="btn btn-outline-secondary">Обновить</button>
        </p>
        <table class="table table-hover table-striped">
            <thead>
                <tr>
                    <th>
                       #
                    </th>
                    <th>
                        Рақам
                    </th>

                    <th>
                        Деҳа
                    </th>
                    <th>
                        Рамзи деҳа
                    </th>
                    <th>
                        Рамзи деҳаи хурд
                    </th>
                    <th>
                        Эзоҳ
                    </th>

                    <th></th>
                </tr>
            </thead>
            <tbody>
          
                <tr v-for="b in this.$store.state.books" :key="b">
                    <td>
                        {{b.ID}}
                    </td>
                    <td>
                        {{b.Number}}
                    </td>
                    <td>
                       {{b.Name}}
                    </td>
                    <td>
                        {{b.Kds}}
                    </td>
                    <td>
                        {{b.Kds1}}
                    </td>
                    <td>
                        {{b.Comment}}
                    </td>

                    <td>
                        
                         
                    <button @click="pushBook(b)" class="btn btn-success">Просмотр</button> &nbsp;
                    <button @click="updateBook(b)" class="btn btn-primary">Тағирдиҳӣ</button> &nbsp;
                
                    <a asp-action="Delete" class="btn btn-danger">Нобудкунӣ</a>

                         <br>

                    </td>
                </tr>
                
            </tbody>
        </table>
    </div>
</div>

</template>

<script>

//import axios from 'axios'

export default {
  name: 'Books',

  data(){

    return {
//books:{}
dissave:false,
    }
  },
  methods:{
    
         async   fetchBook(){
            this.dissave=true;
                    console.log('start2222');
                    this.$api(  "/api/data/1/"+this.$store.state.terid)
                   // .then(res => res.json())
                    .then(data => this.$store.state.books=data)
                    .catch(error => {
                          console.error("There was an error!", error)
                    });

                    console.log('stop2222');
                    this.dissave=false;
            } ,

            pushBook(b){
                this.$store.state.book=b;
                this.$router.push('/Households');
            },
            updateBook(b){
                this.$store.state.book=b;
                this.$router.push('/Book');
            }

            

  },
   mounted () {



    console.log('mounted', this.$store.state.books.length)

    if (this.$store.state.books.length==0)
    {
         this.fetchBook();
        console.log('update book')
    }
 
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 
</style>
